/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AddFacilityPage = lazyLoad(
  () => import('./index'),
  module => module.AddFacilityPage,
);
